// Same shape already established in features/exercise/hooks/use-reopen-camera-when-errors.jsx
// (console.warn only — the eslint config allows warn/error, not log), now
// shared so every camera log line looks the same regardless of which module
// emitted it.
export function logCamera(reason, extra = {}) {
  console.warn('[CAMERA]', {
    reason,
    visibilityState: typeof document !== 'undefined' ? document.visibilityState : undefined,
    ...extra,
  });
}
